"use client";

import * as React from "react";
import { cn } from "./lib/utils";
import { IQButton } from "./iq-button";

export interface DropdownProps {
  label: React.ReactNode;
  href?: string;
  target?: React.HTMLAttributeAnchorTarget;
  alignment?: "left" | "right" | "center";
  children?: React.ReactNode;
  twoColumns?: boolean;
}

export function Dropdown({
  label,
  href,
  target,
  alignment = "left",
  children,
  twoColumns = false,
}: DropdownProps) {
  const [opened, setOpened] = React.useState(false);

  const toggle = (
    <IQButton variant="colorOnHover" size="sm" color="greyLighter">
      {label}
    </IQButton>
  );

  // Simple link without dropdown children
  if (!children && href) {
    return (
      <div className="relative mt-[5px] border-b-[5px] border-b-transparent">
        <a href={href} target={target}>
          {toggle}
        </a>
      </div>
    );
  }

  return (
    <div
      className="group relative mt-[5px] border-b-[5px] border-b-transparent"
      onMouseEnter={() => setOpened(true)}
      onMouseLeave={() => setOpened(false)}
    >
      {href ? (
        <a
          href={href}
          target={target}
          onClick={() => setOpened(false)}
          className="group-hover:[&_button]:bg-[#f8f8f8]"
        >
          {toggle}
        </a>
      ) : (
        <div
          onClick={() => setOpened((o) => !o)}
          className="group-hover:[&_button]:bg-[#f8f8f8]"
        >
          {toggle}
        </div>
      )}
      {children && (
        <div
          className={cn(
            "absolute top-full mt-[5px] z-[300] min-w-full py-[5px] rounded-[5px] bg-white transition-opacity duration-100 ease-out overflow-y-auto",
            opened
              ? "opacity-100 pointer-events-auto shadow-[0_2px_4px_rgba(0,0,0,0.25)]"
              : "opacity-0 pointer-events-none",
            alignment === "left" && "left-0",
            alignment === "right" && "right-0",
            alignment === "center" && "left-1/2 -translate-x-1/2",
            twoColumns && "grid grid-cols-2 gap-[5px]"
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
}
